import React from 'react';
import { observer } from 'mobx-react';
import { Button, Dialog, Typography } from '@material-ui/core';
import * as EstadosSolicitud from '../../utils/EstadosSolicitud';

import '../../styles/PopUp.scss';

import ButtonPdfComponent from './ButtonPdfComponent';

const SOLICITUD=1;
const OFERTA_COMPLETA=2;
const OFERTA_ACEPTADA=3;

const styles = {
  popupstyle: {
    width: '100%',
  },
  popupTitle: {
    width: '100%',
  },
  iconStyle: {
    alignSelf: 'center',
    marginRight: '10px',
  },
  panelStyle: {
    marginTop: '15px',
  },
};

const PopUp = observer(
  class PopupBotonesPDf extends React.Component {

    hide = () => {
      if (this.props.onClose) {
        this.props.onClose();
      }
    };

    documentoSeleccionado=(tipoDoc)=>{
      if(this.props.onDocumentoSeleccionado){
        this.props.onDocumentoSeleccionado(tipoDoc);
      }
    }

    renderDocumentos=(estadoSolicitud)=>{
      let result;
      if(estadoSolicitud === EstadosSolicitud.OFERTA_DISPONIBLE){
        result=<div>
          <ButtonPdfComponent tituloDocumento="Certificado Solicitud" tipoDoc={SOLICITUD} onClick={this.documentoSeleccionado}/>
          <ButtonPdfComponent tituloDocumento="Detalle Oferta Banco Ripley" tipoDoc={OFERTA_COMPLETA} onClick={this.documentoSeleccionado}/>
        </div>
      }else if (estadoSolicitud === EstadosSolicitud.OFERTA_ACEPTADA||estadoSolicitud===EstadosSolicitud.ACEPTACION_PARCIAL){
        result=<div>
          <ButtonPdfComponent tituloDocumento="Certificado Solicitud" tipoDoc={SOLICITUD} onClick={this.documentoSeleccionado}/>
          <ButtonPdfComponent tituloDocumento="Detalle Oferta Banco Ripley" tipoDoc={OFERTA_COMPLETA} onClick={this.documentoSeleccionado}/>
          <ButtonPdfComponent tituloDocumento="Detalle Oferta Aceptada" tipoDoc={OFERTA_ACEPTADA} onClick={this.documentoSeleccionado}/>
        </div>
      }else{
        result=<div>
          <ButtonPdfComponent tituloDocumento="Certificado Solicitud" tipoDoc={SOLICITUD} onClick={this.documentoSeleccionado}/>
        </div>
      }
      return result;
    }

    render() {

      return (
        <Dialog id="modal" modal="true" open={this.props.open} style={styles.popupstyle}>
          <div className="Panel" style={styles.panelStyle}>
            <div className="titlePopup">
              <div id="txtTituloModal" style={styles.popupTitle}></div>
            </div>
            <div className="boxMensaje">
              <div className="mensaje">
                <Typography className="boldTitulo">Los documentos asociados a tu solicitud son los siguientes:</Typography>
                  {this.renderDocumentos(this.props.estadoSolicitud)}
              </div>
              <div className="boxButton">
                <Button id="btnPopUpCerrar" variant="contained"
                color="primary"  className="btnRipleyAmarillo" 
                fullWidth={true}
                onClick={this.hide}>
                  cerrar
                </Button>
              </div>
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }
);

//const PopUp = withStyles(styles)(PopUpMandatoComponent);

export default PopUp;
